<template>
    <div>
        <div style="margin-bottom: 10px;color: #888;font-size: 13px;">
            以链接添加
            
        </div>
        <el-input type="textarea" v-model="all_url" :rows="3" placeholder="一行一个链接"></el-input>
        <el-link style="font-size: 13px;" type="danger">需要上传视频？点击下载上传工具</el-link>
        <div style="margin-top: 20px;color: #888;font-size: 13px;">填写信息</div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
            仓库名称：
            <el-input placeholder="请填写名称" v-model="ku_name" style="width:200px;" size="small" maxlength="6"
                show-word-limit>
            </el-input>
        </div>
        <div style="display: flex;align-items: center;margin-top: 15px;">
            仓库图片：
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/" 
                :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-progress="uping">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </div>
        <div style="margin-top: 30px;">
            <el-button type="success" style="width: 100px;" @click="cj">创建</el-button>
        </div>
        
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            all_url: '',
            ku_name: '',
            imageUrl: ''
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        handleAvatarSuccess(res, file) {
            console.log(file)
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        uping(e){
            // console.log(e)
        },
        cj(){
            if(this.ku_name==''){
                this.$msg.error('请填写名称')
                return
            }
            if(this.all_url==''){
                this.$msg.error('请填写视频链接')
                return
            }
        }
        
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.avatar-uploader{
    border: 1px dashed #919191;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.el-upload {
    border: 1px dashed #919191;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.avatar {
    width: 60px;
    height: 60px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Videohome_add.vue


// WEBPACK FOOTER //
// src/components/User/Videohome_add.vue